(() => {
  if (customElements.get('section-endorsements')) {
    return;
  }

  class SectionEndorsements extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.observer = null;
    }

    connectedCallback() {
      // Small delay to ensure Swiper is loaded
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSlider(), 100);
      } else {
        this.initSlider();
      }
      this.initIntersectionObserver();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      // Make sure Swiper is loaded
      if (typeof Swiper === 'undefined') {
        console.warn('Swiper is not loaded yet');
        return;
      }

      const slides = this.querySelectorAll('.swiper-slide');

      // Check for reduced motion preference
      const respectsReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.slider-prev'),
          nextEl: this.querySelector('.slider-next'),
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
        },
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 20,
        speed: respectsReducedMotion ? 0 : 300,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: 3,
            centeredSlides: true,
          },
          1023: {
            slidesPerView: 4,
            centeredSlides: true,
          },
          1460: {
            slidesPerView: 6,
            centeredSlides: false,
          },
        },
      };

      this.slider = new Swiper(sliderElement, this.options);
    }

    initIntersectionObserver() {
      const lastSlide = this.querySelector('.swiper-slide:last-child .slide__image');
      if (!lastSlide) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('section-endorsements--last-item-visible');
          } else {
            this.classList.remove('section-endorsements--last-item-visible');
          }
        });
      });

      this.observer.observe(lastSlide);
    }
  }

  customElements.define('section-endorsements', SectionEndorsements);
})();
